'use client';

import {tokens as darkTokens} from './generated/dark';
import {tokens as lightTokens} from './generated/light';
import type {IconProps, IconType} from './icons';

import {
  FiArrowLeft,
  FiArrowRight,
  FiExternalLink,
  FiLogOut,
  FiUploadCloud,
  FiUser,
  FiXSquare,
  RxTriangleDown,
  RxTriangleUp,
} from './icons';

export {withStylesProvider} from './utils/withStylesProvider';
export {ButtonGroup} from '@chakra-ui/react';

export {toShadow} from './theme/shadows';
export {tokens as darkTokens} from './generated/dark';
export {tokens as lightTokens} from './generated/light';
export {ChakraProvider, useDisclosure, useRadio, useRadioGroup} from '@chakra-ui/react';
export * from './components';
export {IconButton, List, ListItem} from './components';
// Re-export individual icons
export {
  FiArrowLeft,
  FiArrowRight,
  FiExternalLink,
  FiLogOut,
  FiUploadCloud,
  FiUser,
  FiXSquare,
  RxTriangleDown,
  RxTriangleUp,
};
export type {IconType, IconProps};
export * from '@chakra-ui/react-use-size';
export * from './utils/create-store';
export type {
  Calendar,
  CalendarDate,
  CalendarDateTime,
  DateDuration,
  DateFormatter,
  DateValue,
  ZonedDateTime,
} from '@internationalized/date';

export {toCalendarDate, getLocalTimeZone, today, parseDate} from '@internationalized/date';

export * from './helpers/hotkeys';
export * from './hooks/useMouseMove';
export * from './hooks/useSlots';
export * from './types';
export * from './utils/dom';
export {mergeSXProp} from './utils/merge-sx-prop';
export {uiTheme} from './theme';
export const tokens = {
  light: lightTokens,
  dark: darkTokens,
};
